import {Component, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-template-menu-section",
    imports: [],
    templateUrl: "./template-menu-section.component.html",
    styleUrl: "./template-menu-section.component.scss",
})
export class TemplateMenuSectionComponent {}
